<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="50%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    :createButtonDisabled="!$can('create','Packaging')"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_PACKAGING_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.packaging;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function(packaging) {
      // console.log("packaging", packaging, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(packaging, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_ACCOUNT_PACKAGING_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(packaging, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.createPackaging.errors

          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created", response.data.createPackaging.packaging);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_PACKAGING_QUERY = gql `
  {
    accountContext {
      packaging {
        id
        name
        packagingTypeId
        packagingType {
          id
          name
        }
        size
        unitId
        unit {
          id
          name
        }
        validations
      }
    }
    globalContext {
      allPackagingTypes {
        id
        name
        shortName
        description
      }
      allUnits {
        id
        name
        fullName
      }
      allCustomUnits {
        id
        name
      }
    }
  }
`;

const CREATE_ACCOUNT_PACKAGING_MUTATION = gql `
  mutation($input: PackagingCreateInputObject!) {
    createPackaging(input: $input) {
      packaging {
        id
        name
        packagingTypeId
        packagingType {
          id
          name
        }
        size
        unitId
        unit {
          id
          name
        }
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
